import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal/lib/components/Modal';
import styles from './GenericDialog.module.css';
import DefaultButton from '../forms/DefaultButton';

const GenericDialog = (
  {
    isOpen,
    onRequestClose,
    data
  }
) => {
  function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  const message = Object.entries(data)
  message[0].shift()

  return (
    <Modal
      isOpen={isOpen}
      ariaHideApp={false}
      contentLabel="Selected Option"
      overlayClassName="react-modal-overlay"
      className="react-modal-content"
      onRequestClose={onRequestClose}
    >
      <div className={styles.GenericDialog}>
        {message.map((msg) => (
          <h1>{capitalize(msg[0])}{msg[1] ? ': ' + msg[1] : ''}</h1>
        ))}
        <div className={styles.contentModalBtn}>
          <DefaultButton
            type={`red`}
            size="MD"
            onClick={onRequestClose}
            children="OK"
          />
        </div>
      </div>
    </Modal>
  )
}

GenericDialog.propTypes = {};
GenericDialog.defaultProps = {};

export default GenericDialog;
